import Error from './Error';

export default () => <Error loading flat />;
